// client/src/App.js
import React, { useState } from 'react';
import './App.css';
import SearchForm from './components/SearchForm';
import BannerDisplay from './components/BannerDisplay';
import InfoSection from './components/InfoSection';
import Legal from './components/Legal';
import config from './config';

function App() {
  // State to manage the app
  const [bannerData, setBannerData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showLegal, setShowLegal] = useState(false);
  
  // Function to handle the API request to extract banner
  const handleExtractBanner = async (artistUrl, deviceType = 'desktop') => {
    // Reset states
    setIsLoading(true);
    setError(null);
    setBannerData(null);
    
    try {
      // Call the backend API
      const response = await fetch(`${config.apiUrl}/api/extractbanner`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ artistUrl, deviceType }),
      });
      
      // Parse the response
      const result = await response.json();
      
      if (!result.success) {
        throw new Error(result.error || 'Something went wrong');
      }
      
      // Set the banner data on success
      setBannerData(result.data);
    } catch (err) {
      console.error('Error extracting banner:', err);
      setError(err.message || 'failed to extract banner');
    } finally {
      setIsLoading(false);
    }
  };
  
  if (showLegal) {
    return <Legal onBack={() => setShowLegal(false)} />;
  }

  return (
    <div className="app">
      <a 
        href="https://github.com/fromis-9/spotify-banner" 
        target="_blank" 
        rel="noopener noreferrer"
        className="github-link"
        title="View on GitHub"
      >
        <svg className="github-icon" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
        </svg>
      </a>
      
      <header className="app-header">
        <h1 className="green">spotify</h1><h1 className="white">banner</h1><h3 className="title">.com</h3>
        <p className="subtitle">get an artist's spotify banner/header image</p>
      </header>
      
      <main className="app-content">
        <SearchForm 
          onSubmit={handleExtractBanner} 
          isLoading={isLoading} 
        />
        
        {error && (
          <div className="error-message">
            <p>{(error || '').toLowerCase()}</p>
          </div>
        )}
        
        {bannerData && <BannerDisplay data={bannerData} />}
        
        <InfoSection />
      </main>
      
      <footer className="app-footer">
        <p>
          not affiliated with spotify | <a href="https://github.com/fromis-9" target="_blank" rel="noopener noreferrer">corinthians</a> | <button className="legal-link" onClick={() => setShowLegal(true)}>legal</button>
        </p>
      </footer>
    </div>
  );
}

export default App;